<!-- fieldAwesome.vue -->
<template>
    <div class="max-width">
        <input
               class="form-control input-text"
               type="number"
               v-model="rawValue"
               :disabled="schema.disabled"
               :maxlength="schema.max"
               :placeholder="schema.placeholder"
               :readonly="schema.readonly" >
        <span class="unit">
            <span v-if="typeof schema.unitText == 'function'">
                {{schema.unitText()}}
            </span>
            <select  v-if="typeof schema.units == 'function'" v-model="selected" v-class="{'form-control': true, 'hidden': schema.units().length < 2}">
                <option v-for="(item, index) in  schema.units()" :value="item.value">{{item.label}}</option>
            </select>
        </span>
    </div>
</template>

<script>
import { abstractField } from 'vue-form-generator'

export default {
    mixins: [ abstractField ],
    data () {
        return {
            selected: 1000,
            rawValue: typeof this.schema.units == 'function' ? 0 : 1,
        }
    },
    watch: {
        rawValue (value) {
            if (typeof this.schema.units == 'function') {
                this.value = '' + (this.selected * value)
            } else {
                this.value = '' + value
            }
        },
        selected (value, old) {
            if (typeof this.schema.units == 'function') {
                this.rawValue = this.value = '' + ((old * this.rawValue) / value)
            } else {
                this.value = '' + this.rawValue
            }
        },
        model (value) {
            if (typeof this.schema.units == 'function') {
                this.rawValue = this.value / this.selected
            } else {
                this.rawValue = '' + this.value
            }
        }
    }
}
</script>

<style scoped>
.input-text {
    width: 150px !important;
    display: inline-block !important;
    vertical-align: middle;
}

.unit {
    display: inline-block;
    margin-left: 8px;
    vertical-align: middle;
}

.max-width {
    width: 100%;
    font-size: 15px !important;

}
.unit select {
    width: 80px !important;
    height: 34px;
    padding-top: 5px !important;
}
.input-text:disabled {
    background-color: #eee;
}
</style>
